<app-nav></app-nav>
<section class="col-md-10 offset-md-1 show-mob">
  <div class="row" *ngIf="requestedQuotesList.length > 0">
    <ng-container *ngFor="let quotes of requestedQuotesList | slice:0:quoteLength">
      <div class="col-md-6" *ngIf="quotes.premium">
        <div class="requested-card">
          <div (click)="routeToQuotePage(quotes.quoteId)">
          <div class="row text-center">
            <div class="col-8">
              <h5>{{quotes.product}}</h5>
            </div>
            <div class="col-4">
              <img class="insur-logo" *ngIf="quotes.insurerLogo[0] && quotes.insurerLogo[0] !== 'N/A'" [src]="quotes.insurerLogo[0]" />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <label>Premium (Excluding Taxes)</label>
              <div class="amount">₹ {{quotes.premium}}</div>
            </div>
            <div class="col-6">
              <label>Quote ID</label>
              <!-- <div class="date">{{quotes.quoteId}} </div> -->
              <form ngNoForm action={{actionUrl}} method="GET">
                <input type="hidden" name="quoteId" value={{quotes.quoteId}} />
                <input type="submit" value={{quotes.quoteId}} class="QuoteId quoteId-Color" />
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label>Date</label>
              <div class="date">{{quotes.date | date}}</div>
            </div>
            <div class="col-6">
              <label>Payment Status</label>
              <div [ngClass]="quotes.paymentStatus.toUpperCase()==='SUCCESS' ? 'paid' : 'unpaid'">
                {{quotes.paymentStatus.toUpperCase()==='SUCCESS' ? 'Paid' : 'Not Paid'}}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </ng-container>
    <div class="col-md-12 text-center mt-3 mb-3">
      <button class="btn btn-orange more-btn" *ngIf="quoteLength === 11"
        (click)="quoteLength = requestedQuotesList.length">See More</button>
    </div>
  </div>
  <!-- <div class="row" *ngIf="requestedQuotesList.length === 0">
    <div class="products-list">
      <ul>
        <li *ngFor="let product of productsList">
          <p (click)="createProspect(product.productId)">{{product.productName}}</p>
        </li>
      </ul>
    </div>
    <div style="margin-left: 7%; margin-top: 5%;">
      <h4 [hidden]="loading">Currently no quotes are available</h4>
    </div>
  </div> -->
</section>


<section class="col-md-10 offset-md-1 show-desktop">
  <div class="row" *ngIf="requestedQuotesList.length > 0">
    <ng-container *ngFor="let quotes of requestedQuotesList | slice:0:quoteLength">
      <div class="col-md-5 mr-05 ml-05" *ngIf="quotes.premium">
        <div class="requested-card-desk">
         <div class="row text-center mb-20">
            <div class="col-8">
              <h5>{{quotes.product}}</h5>
            </div>
            <div class="col-4">
              <img class="insur-logo" *ngIf="quotes.insurerLogo[0] && quotes.insurerLogo[0] !== 'N/A'" [src]="quotes.insurerLogo[0]" />
            </div>
          </div>
          <div class="row mb-20">
            <div class="col-6">
              <label>Premium (Excluding Taxes)</label>
              <div class="amount">₹ {{quotes.premium}}</div>
            </div>
            <div class="col-6 pl-15">
              <label>Quote ID</label>
              <div class="date">{{quotes.quoteId}} </div>
            </div>
          </div>
          <div class="row mb-20">
            <div class="col-6">
              <label>Date</label>
              <div class="date">{{quotes.date | date}}</div>
            </div>
            <div class="col-6 pl-15">
              <label>Payment Status</label>
              <div [ngClass]="quotes.paymentStatus.toUpperCase()==='SUCCESS' ? 'paid' : 'unpaid'">
                {{quotes.paymentStatus.toUpperCase()==='SUCCESS' ? 'Paid' : 'Not Paid'}}</div>
            </div>
          </div>
          <div class="col-md-12 text-center mt-3 mb-3">
            <button class="btn btn-white more-btn"
            (click)="routeToQuotePage(quotes.quoteId)">Show Quote</button>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="col-md-12 text-center mt-3 mb-3">
      <button class="btn btn-orange more-btn" *ngIf="quoteLength === 11"
        (click)="quoteLength = requestedQuotesList.length">See More</button>
    </div>
  </div>
  <!-- <div class="row" *ngIf="requestedQuotesList.length === 0">
    <div class="products-list">
      <ul>
        <li *ngFor="let product of productsList">
          <p (click)="createProspect(product.productId)">{{product.productName}}</p>
        </li>
      </ul>
    </div>
    <div style="margin-left: 35%; margin-top: 2%;">
      <h4 [hidden]="loading">Currently no quotes are available</h4>
    </div>
  </div> -->
</section>

<!-- Modal -->
<!-- Modal -->
<div class="modal fade" id="quoteModal" tabindex="-1" role="dialog" aria-labelledby="quoteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <!-- Close button in top-right corner -->
      <div class="modal-header p-0 border-0">
        <button type="button" class="close pr-3 pt-2" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <h5 class="modal-title mb-3" id="quoteModalLabel">No existing Quotes found</h5>
        <p>Want to Compare Quotes and Buy insurance online ?</p>
        <button class="btn btn-light border mt-3" (click)="createProspect()">Visit SecureNow Website</button>
      </div>
    </div>
  </div>
</div>



<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>